import React, { useState, useEffect, useContext } from 'react'
import { encodeForURL } from '../../../global/formatters/string-formatter'
import { BrManageContentButton } from '@bloomreach/react-sdk'
import { types } from '../types.js'
import {
  getLinkFromRef,
  getLink,
  isLocal,
  isCms,
  isProduction,
  getLocalPath,
  GlobalContext,
  getUrlParameter,
  useTaxonomies,
  isQa,
} from '../../utility'

import { fetchData } from '../../data'
import { Link2 } from '..'

export function Social({ page, component }) {
  // console.log('SOCIAL PAGE >>>>', page)
  // console.log('SOCIAL COMPONENT >>>>', component)

  const taxonomies = useTaxonomies()

  const searchParamId = getUrlParameter('id')

  const [apiDocument, setApiDocument] = useState()

  const [parameters, setParameters] = useState({
    style: null,
  })

  const [blurb, setBlurb] = useState({
    id: null,
    document: null,
    title: null,
    subtitle: null,
    publicationDate: null,
    html: null,
    imageUrl: null,
    imageDescription: null,
    time: null,
    keys: null,
    videoId: null,
    itemType: null,
    link: null,
    linkList: null,
  })

  const { setDocument } = useContext(GlobalContext)

  useEffect(() => {
    const _parameters = component?.getParameters()

    // console.log('SOCIAL PARAMETERS >>>>', _parameters)

    const _models = component?.getModels() || {}

    // console.log('SOCIAL MODELS >>>>', _models)

    const { document: _documentRef } = _models

    // console.log('SOCIAL DOCUMENTREF >>>>', _documentRef)

    const _document = _documentRef && page.getContent(_documentRef)

    // console.log('SOCIAL DOCUMENT >>>>', _document)

    setParameters({
      style: _parameters.style,
    })

    if (!searchParamId) {
      const translatedData = {}

      if (_document) {
        const data = _document.getData()

        // console.log('SOCIAL DATA >>>', data)

        translatedData.title = data.title
        translatedData.subtitle = data.subtitle || data.subhead
        translatedData.publicationDate = data.publicationDate
        translatedData.html =
          data.html && typeof data.html === 'object'
            ? data.html.value
            : data.html || data.content
        translatedData.imageRef = data.image || data.heroImage
        translatedData.time = data.time
        translatedData.keys = data.keys
        translatedData.videoId = data.videoId
        translatedData.itemType = data.itemType
        translatedData.link = data.linkCompound
        translatedData.linkList = data.linkList
      }

      const {
        title,
        subtitle,
        publicationDate,
        html,
        imageRef,
        time,
        keys,
        videoId,
        itemType,
        link,
        linkList,
      } = translatedData

      const image = imageRef && page?.getContent(imageRef)

      const imageUrl = image?.getOriginal().getUrl()
      const imageDescription = image?.getDescription()

      const blurb = {
        id: null,
        document: _document,
        title: title,
        subtitle: subtitle,
        publicationDate: publicationDate,
        html: html,
        imageUrl: imageUrl,
        imageDescription: imageDescription,
        time: time,
        keys: keys,
        videoId: videoId,
        itemType: itemType,
        link: getLink(getLinkFromRef(link, page), null),
        linkList: linkList?.links
          .filter((l) => l.link && l.link.length > 0)
          .map((l) => getLink(getLinkFromRef(l, page), null)),
      }

      setBlurb(blurb)

      setTimeout(() => {
        setDocument(blurb)
      }, 2000)
    }
  }, [page, component])

  useEffect(() => {
    if (!searchParamId) {
      setApiDocument(null)
    }

    if (
      searchParamId &&
      (!apiDocument || apiDocument.url.indexOf(searchParamId) < 0)
    ) {
      const documentUrl = `${getLocalPath()}/halapi/documents/${searchParamId}`

      setApiDocument({ url: documentUrl })
    }
  }, [page, component])

  useEffect(() => {
    if (apiDocument && apiDocument.url && !apiDocument.payload) {
      const fetchAsync = async () => {
        const data = await fetchData(apiDocument.url)

        // console.log('SOCIAL FETCH DATA >>>', data)

        if (data) {
          setApiDocument({ url: apiDocument.url, payload: data })
        }
      }

      fetchAsync()
    }
  }, [apiDocument])

  useEffect(() => {
    if (apiDocument && apiDocument.payload) {
      const data = apiDocument.payload

      const document = {
        id: data['_meta']['id'],
        title: data['title'],
        subtitle: data['subtitle'],
        publicationDate:
          data['publicationDate'] < 0 ? null : data['publicationDate'],
        html: data['html']['content'],
        imageUrl: data?.['image']?.['_meta']?.['mirror']?.['path']
          ? `${isLocal() || isCms() ? '/site' : ''}/binaries/${
              data['image']['_meta']['mirror']['path']
            }`
          : '',
        time: data['time'],
        keys: data['keys'],
        videoId: data['videoId'],
        itemType: data['itemType'],
        link: null,
      }

      setBlurb(document)

      setTimeout(() => {
        setDocument(document)
      }, 2000)
    }
  }, [apiDocument])

  const pagehref =
    isQa() || isProduction()
      ? window.location.href
      : 'https://www.columbiathreadneedleus.com/institutional'

  const _href = encodeURIComponent(pagehref)

  const _pageTitle = blurb.title || page.getTitle()
  const _pageTitleEncoded = encodeURIComponent(_pageTitle)

  const _hrefLinkedIn = `https://www.linkedin.com/sharing/share-offsite/?url=${_href}`
  const _hrefTwitter = `https://twitter.com/intent/tweet?url=${_href}&text=${_pageTitleEncoded}`

  const emailLink = `mailto:?subject=${_pageTitle}&body=${_pageTitle}`
  const encodeEmailLink = `${encodeForURL(emailLink)}${encodeURI(
    '\r\n\r\n'
  )}${encodeForURL(pagehref)}`

  const _isHidden = parameters.style === 'Hidden' && !page.isPreview()

  return (
    !_isHidden && (
      <div
        id={blurb.title?.replaceAll(' ', '').replaceAll("'", '')}
        className={`Social2 u-posRelative u-sizeConstrained ${
          blurb.keys && blurb.keys.length > 0 ? 'u-sizeConstrainedNarrow' : ''
        } u-marginVert12gu`}
      >
        <BrManageContentButton content={blurb.document} />
        <div className="u-flex u-sm-flexCol u-flexAlignItemsCenter">
          {blurb.keys && blurb.keys.length > 0 && (
            <div className="u-flex u-flexAlignItemsCenter u-md-size1of2 u-lg-size1of2">
              <div className="u-textSecondary u-textBold">Topics:</div>
              <div className="u-flex u-marginLeft2gu u-textColorBrandLight u-textSizeMsrm1 u-textItalic u-textCapitalize">
                {blurb.keys.sort().map((key, index) => (
                  <React.Fragment key={key}>
                    {index > 0 && <span>,&nbsp;</span>}
                    <Link2
                      url={
                        isLocal()
                          ? `/site/cti-institutional/insights/latest-insights?topic=${key}`
                          : `/institutional/insights/latest-insights?topic=${key}`
                      }
                      text={
                        (taxonomies?.length > 0 &&
                          taxonomies.find((taxonomy) => taxonomy.key === key)
                            ?.name) ||
                        key.replaceAll('-', ' ')
                      }
                    />
                  </React.Fragment>
                ))}
              </div>
            </div>
          )}
          <div
            className={`u-flex u-flexAlignItemsCenter ${
              blurb.keys && blurb.keys.length > 0 ? 'u-flexJustifyEnd' : ''
            } u-md-size1of2 u-lg-size1of2 u-sm-marginTop4gu`}
          >
            <div className="u-textSecondary u-textBold">Share:</div>
            <div
              className="u-flex u-flexAlignItemsCenter u-marginLeft3gu"
              data-analytics="social-media-links-btn"
            >
              <div className="u-flex u-flexAlignItemsCenter">
                <div>
                  <img
                    src={`${
                      isLocal() || isCms() ? '/site' : ''
                    }/webfiles/latest/assets/cti/images/icon_linkedin.svg`}
                    alt="LinkedIn"
                  />
                </div>
                <div className="u-marginLeft1gu">
                  <a
                    className="Link"
                    href={_hrefLinkedIn}
                    target="_blank"
                    rel="noreferrer"
                    data-analytics="linkedin-btn"
                  >
                    LinkedIn
                  </a>
                </div>
              </div>
              <div className="u-flexAlignItemsCenter u-marginLeft5gu u-hidden">
                <div>
                  <img
                    src={`${
                      isLocal() || isCms() ? '/site' : ''
                    }/webfiles/latest/assets/cti/images/icon_twitter.svg`}
                    alt="Twitter"
                  />
                </div>
                <div className="u-marginLeft1gu">
                  <a
                    className="Link"
                    href={_hrefTwitter}
                    target="_blank"
                    rel="noreferrer"
                    data-analytics="twitter-btn"
                  >
                    Twitter
                  </a>
                </div>
              </div>
              <div className="u-flex u-flexAlignItemsCenter u-marginLeft5gu">
                <div>
                  <img
                    src={`${
                      isLocal() || isCms() ? '/site' : ''
                    }/webfiles/latest/assets/cti/images/icon_email.svg`}
                    alt="Email"
                  />
                </div>
                <div className="u-marginLeft1gu">
                  <a
                    className="Link"
                    href={encodeEmailLink}
                    target="_blank"
                    rel="noreferrer"
                    data-analytics="email-btn"
                  >
                    Email
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  )
}

Social.propTypes = {
  ...types,
}
